import {httpPost} from "../http/axios";


// 学习中心
export function soundMarkCenter(data) {
    return httpPost('/api/phonogram_symbol/index', data)
}
// 基础音标
export function basisPhonetic(data) {
    return httpPost('/api/phonogram_symbol/basis', data)
}
// 递进课程
export function videoList(data) {
    return httpPost('/api/phonogram_symbol/video_list', data)
}
// 选课中心
export function curriculum(data) {
    return httpPost('/api/phonogram_symbol/curriculum', data)
}

export function soundmarkCheckTry(data) {
    return httpPost('/api/phonogram_symbol/check_try', data, '获取课程剩余次数')
}
export function soundmarkSaveCourse(data) {
    return httpPost('/api/phonogram_symbol/save_choice', data, '选课中心保存')
}
export function soundmarkCourseList(data) {
    return httpPost('/api/phonogram_symbol/curriculum', data, '选课中心页面')
}